import React from 'react';
import ReactDOM from 'react-dom';
import * as WebFont from 'webfontloader';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

WebFont.load({
  google: {
    families: ['Roboto:300,400,500,700', 'sans-serif'],
  },
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
